enum Size {
  Tiny,
  Medium,
  Large,
}

export default Size;
